import React, { useState, useEffect, useMemo, useCallback } from 'react';

import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Cell,
} from 'recharts';
import { useLocation, useNavigate } from 'react-router-dom';

// import votesData from '../jan12d-votes-1736723725905127000.json';
import questions from '../questions.json';
import detailedQuestions from '../detailed_questions.json'

type DrillDownInfo = {
  questionNumber: number;
  showData: { [key: string]: number };
  rawData: Array<{ showID: string; ballotID: string; promptID: string; userInputData: string }>;
};

type VoteEntry = {
  ID: string;
  showID: string;
  userID: string;
  userID2: string;
  timestamp: string;
  ballotID: string; // Equivalent to questionNumber
  promptID: string;
  userInputData: string;
};

type PromptCount = {
    promptID: string;
    [showID: string]: number | string;
  };

const Vis2DrillDown: React.FC = () => {
    const location = useLocation();
    const navigate = useNavigate();
    
    const { questionNumber, showData, rawData } = location.state as DrillDownInfo;

    console.log("questionNumber: " , questionNumber)
    console.log("showData: ", showData)

    const [promptCounts, setPromptCounts] = useState<PromptCount[]>([]);
    const [showIDs, setShowIDs] = useState<string[]>([]);

    console.log("promptCounts: ", promptCounts)
    console.log("showIDs: ", showIDs)

    // Extract Prompts for the current questionNumber
    const currentQuestion = detailedQuestions[questionNumber];
    const promptDescriptions: { [key: string]: string } = {};

    console.log("currentQuestion: ", currentQuestion)
    console.log("promptDescriptions: ", promptDescriptions)

    if (currentQuestion && currentQuestion.Prompts) {
    Object.entries(currentQuestion.Prompts).forEach(([pid, prompt]) => {
        promptDescriptions[pid] = (prompt as any).Name;
        console.log ("pid: ", pid)
        console.log("promptDescriptions[pid]: ", promptDescriptions[pid])
      });
    }

    const colors = ['#ffb600', '#0095ff', '#00d37b', '#8900f2', '#ed0062', '#C244B7', '#4300ed'];

    useEffect(() => {
      const counts: PromptCount[] = [];
      const shows: string[] = [];
  
      rawData.forEach(({ showID, ballotID, promptID }) => {
        if (parseInt(ballotID, 10) === questionNumber) {
          let promptCount = counts.find(count => count.promptID === promptID);
          if (!promptCount) {
            promptCount = { promptID };
            counts.push(promptCount);
          }
          if (!promptCount[showID]) {
            promptCount[showID] = 0;
          }
          promptCount[showID] = (promptCount[showID] as number) + 1;
  
          if (!shows.includes(showID)) {
            shows.push(showID);
          }
        }
      });
  
      setPromptCounts(counts);
      setShowIDs(shows);
    }, [rawData, questionNumber]);
  // useEffect(() => {
  //   const uniqueShowIDs = Object.keys(showData)
  //   console.log("useEffect(): uniqueShowIDs: ", uniqueShowIDs)
   
  //   // Sort the showIDs by showID 
  //   uniqueShowIDs.sort((a, b) => {
  //     // If showIDs are purely numeric strings
  //     const numA = parseInt(a, 10);
  //     const numB = parseInt(b, 10);
  //     if (!isNaN(numA) && !isNaN(numB)) {
  //       return numA - numB;
  //     }
  //     // If showIDs are alphanumeric, use localeCompare
  //     return a.localeCompare(b);
  //   });

  //   setShowIDs(uniqueShowIDs);
  //   console.log("useEffect(): uniqueShowIDs: ", uniqueShowIDs)

  //   console.log("useEffect(): questionNumber: ", questionNumber)
  //   // Filter votes for the selected questionNumber

  //   var votesData2

  //   // Trying to fetch the JSON here instead of importing it
  //   fetch('http://172.233.194.230:8080/mysecretkey/getallvotes')
  //   .then(response => response.json())
  //   .then(votesData => {
  //     votesData2 = votesData

  //     console.log("...VotesData2: ", votesData2)

  //     console.log("useEffect(): votesData: ", votesData2)
  //     const filteredVotes: VoteEntry[] = votesData2.filter(
  //       (vote) => parseInt(vote.ballotID, 10) === questionNumber
  //     );
  //     console.log("useEffect(): filteredVotes: ", filteredVotes)

  //     // This gets number of votes for each promptID for each showID
  //     const counts: { [promptID: string]: { [showID: string]: number } } = {};
  //     console.log("useEffect(): counts: ", counts)

  //     // Populating counts data structure
  //     filteredVotes.forEach((vote) => {
  //       console.log("useEffect(): filteredVotes.forEach((vote): ", vote)
  //       const { promptID, showID } = vote;
  //       if (!counts[promptID]) {
  //         counts[promptID] = {};
  //       }
  //       if (!counts[promptID][showID]) {
  //         counts[promptID][showID] = 0;
  //       }
  //       counts[promptID][showID]++;
  //     });
    
  //     // Converting to a final array for the graph
  //     const countsArray: PromptCount[] = Object.keys(counts).map((pid) => ({
  //       promptID: pid,
  //       ...counts[pid],
  //     }));

  //     setPromptCounts(countsArray);
  //   })
  //   .catch(error => console.error('Error fetching votes data:', error));

  // }, [questionNumber, showData]);

  const overviewPage = () => {
    navigate('/VisHelper'); 
  };

  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      return (
        <div
          style={{
            backgroundColor: '#21203b',
            padding: '10px',
            borderRadius: '8px',
            color: '#fff',
            fontSize: '16px'
          }}
        >
          {payload.map((entry: any, index: number) => (
            <p key={`tooltip-${index}`} style={{ color: entry.color, margin: 0 }}>
              {entry.name}: {entry.value} votes
            </p>
          ))}
        </div>
      );
    }
    return null;
  };

  const CustomizedXAxisTick = ({ x, y, payload }: any) => {
    const pid = payload.value;
    const description = promptDescriptions[pid] || ''; // promptDescriptions contains the name of the choice for the questions
    console.log("CustomizedXAxisTick(): description: ", description)
    return (
      <g transform={`translate(${x},${y})`}>
        <text
          x={0}
          y={0}
          dy={16}
          textAnchor="end"
          fill="#BCBCBC"
          fontSize={16}
        >
          {description}
        </text>
      </g>
    );
  };



  return (
    <div className="Vis2DrillDown">
      <header className="Vis2DrillDown-header" style={{ padding: '20px' }}>
      <h2
        style={{
            textAlign: 'center',
            marginBottom: '40px',
        }}
        >
        {`Voting results for question ${questionNumber}: ${questions[questionNumber]}`}</h2>
        {promptCounts.length > 0 && showIDs.length > 0 ? (
          <ResponsiveContainer width="100%" height={500}>
            <BarChart
              data={promptCounts}
              margin={{ top: 20, right: 20, left: 20, bottom: 20 }}
            >
              <XAxis
              dataKey="promptID"
              tick={<CustomizedXAxisTick />}
              label={{ value: 'Choice', position: 'insideBottomRight', offset: -10 }}
            />
            <YAxis
              tick={{ fontSize: 16 }}
              label={{ value: 'Votes', angle: -90, position: 'insideLeft' }}
            />
              <Tooltip
                  content={<CustomTooltip />}
                  cursor={{ fill: 'rgba(128, 128, 128, 0.5)' }}
                />
              
              <Legend offset= {-8} margin= {{ top: 40, right: 20, left: 20, bottom: 20 }} />
              {showIDs.map((showID, index) => (
                <Bar
                  key={showID}
                  dataKey={showID}
                  name={showID}
                  fill={colors[index % colors.length]}
                >
                </Bar>
              ))}
            </BarChart>
          </ResponsiveContainer>
        ) : (
          <p></p>
        )}
        <button
          onClick={overviewPage}
          style={{
            position: 'fixed',
            bottom: '20px',
            left: '50%',
            transform: 'translateX(-50%)',
            padding: '10px 20px',
            fontSize: '16px',
            backgroundColor: '#5b58aa',
            color: '#fff',
            border: 'none',
            borderRadius: '8px',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
            cursor: 'pointer',
            transition: 'background-color 0.3s',
          }}
          onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#6a6a7c')}
          onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#5b58aa')}
        >
          Back to Overview
        </button>
      </header>
    </div>
  );
};

export default Vis2DrillDown;
